<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <v-row>
      <v-col
        style="max-width: 15rem !important"
        v-for="(table, index) in tables"
        :key="index"
        cols="12"
        md="3"
      >
        <sub-menu-card
          :title="table.title"
          :isSelected="table.name == $route.name"
          :itemKey="table.key"
          @click="subMenuClicked(table.name)"
        />
      </v-col>
    </v-row>
    <template v-if="$route.name == 'adminLogBroker'">
      <broker-log-form />
    </template>
    <template v-else>
      <log-form v-if="!loading" />
    </template>
  </v-container>
</template>

<script>
import math from '@/mixins/math'
import LogForm from './components/LogForm.vue'
import BrokerLogForm from './components/BrokerLogForm.vue'
import SubMenuCard from '@/components/cards/SubMenuCard'

export default {
  name: 'JarContainer',
  components: {
    SubMenuCard,
    LogForm,
    BrokerLogForm,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      tables: [
        {
          key: 'nirvar',
          title: 'NIRVAR LOG',
          name: 'adminLogNirvar',
        },
        {
          key: 'saperion',
          title: 'SAPERION LOG',
          name: 'adminLogSaperion',
        },
        {
          key: 'jarProcuracy',
          title: 'JAR LOG',
          name: 'adminLogJarProcuracy',
        },
        {
          key: 'asmenys',
          title: 'ASMENYS LOG',
          name: 'adminLogAsmenys',
        },
        {
          key: 'pas',
          title: 'PAS LOG',
          name: 'adminLogPas',
        },
        {
          key: 'broker',
          title: 'BROKER LOG',
          name: 'adminLogBroker',
        },
      ],
    }
  },
  methods: {
    subMenuClicked(route) {
      this.loading = true
       this.$nextTick(() => {
          this.loading = false
          this.$router.push({ name: route })
        })
     
    },
  },
}
</script>


<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>

